module.exports = __webpack_public_path__ + "static/media/manu-13.f10a485f.png";